import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import api from '../../api/endpoints';
import { handleErrors, fetch } from '../../api';

function* editAccountEmail({ payload: { values, onSuccess, handledErrors } }) {
  
  try {
    const { data } = yield call(fetch, { api: api.profile.email_edit, data: values });

    onSuccess();
    yield put(actions.editAccountEmailDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.editAccountEmailFailed,
      handledErrors,
      endpoint: api.profile.email_edit.url
    });
  }
}

export const editAccountEmailSaga = takeEvery(types.EDIT_ACCOUNT_EMAIL_REQUEST, editAccountEmail);